import { VStack, Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { IconMail, IconTel } from '../icons';
import { TextBody, TextBodyBold2 } from '../common/Text'
import SVG from '../common/SVG'

export type FooterGeneralContactProps = BoxProps & {}

const FooterGeneralContact: React.FC<FooterGeneralContactProps> = ({ ...others }) => {
  return (
    <>
      <Box {...others}>
        <VStack spacing="5px" alignItems="flex-start">
          <Box>
            <TextBodyBold2 localizeKey="nav__title__general_contact" />
          </Box>
          <Box>
            <TextBody as="span" localizeKey="nav__body__general_contact_1" />
            {' ('}
            <TextBody as="span" localizeKey="nav__body__general_contact_2" />
            {') '}
          </Box>
          <Box>
            <SVG svg={<IconTel />} w="15px" mr="0.5em" />
            <TextBody as="span" localizeKey="nav__body__general_contact_3" />
          </Box>
          <Box>
            <SVG svg={<IconMail />} w="15px" mr="0.5em" />
            <TextBody as="span" localizeKey="nav__body__general_contact_4" />
          </Box>
        </VStack>
      </Box>
    </>
  )
}

export default FooterGeneralContact
